import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalSection,
  ModalFooter,
  Form,
  CondensedLarge,
  Textarea,
  Button,
} from '@axiom/ui';
import type { TopTask } from '@axiom/validation';

import { WorkspaceTopTaskDismissModalFormSchema } from '../../schema/workspace-top-task-dismiss-modal-form-schema';
import { ActionReputationDetailsApi } from '../../api/action-reputation-details-api';
import { TopTasksApi } from '../../api/top-tasks-api';

export type WorkspaceDismissTopTaskModalProps = {
  topTask: TopTask;
  onClose: () => void;
};

export const WorkspaceDismissTopTaskModal = ({
  topTask,
  onClose,
}: WorkspaceDismissTopTaskModalProps) => {
  return (
    <Form
      schema={WorkspaceTopTaskDismissModalFormSchema}
      name="TOP_TASK_DISMISS_MODAL_FORM"
      initialValues={{
        actionNotes: '',
      }}
      onSubmit={async changedData => {
        if (topTask.reputationDetailsId) {
          await ActionReputationDetailsApi.createActionReputationDetails(
            topTask.reputationDetailsId,
            {
              actionNotes: changedData.actionNotes as string,
              action: 'Dismissed',
            }
          );
          void TopTasksApi.refreshTopTasks();
          onClose();
        }
      }}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="TOP_TASK_DISMISS_MODAL">
            <ModalHeader
              name="TOP_TASK_DISMISS_MODAL_HEADER"
              onClose={() => {
                onClose();
              }}
            >
              Dismiss top task without sending to talent
            </ModalHeader>
            <ModalSection>
              <CondensedLarge name="TOP_TASK_DISMISS_MODAL_DESCRIPTION">
                Please provide your reason for dismissing this top task without
                sharing with the talent and we will forward it to the Axiom
                Talent Experience team.
              </CondensedLarge>
              <Textarea name="actionNotes" label="Additional details" full />
            </ModalSection>
            <ModalFooter>
              <Button
                name="TOP_TASK_DISMISS_MODAL_CANCEL_BUTTON"
                variation="outline"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                name="TOP_TASK_DISMISS_MODAL_SUBMIT_BUTTON"
                onClick={fireSubmit}
              >
                Dismiss Top Task
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};
